export default "__VITE_ASSET__DyfMjsfz__"